<template>
  <div class="home-page" @click="onPageClick">
    <div class="header">
      <span>
        <img src="../assets/logo.png" class="logo" />
      </span>
      <span class="txtus"
        >商务联系：<a target="_blank" href="https://t.me/Topcredit017"
          >@Topcredit017
        </a></span
      >
      <img
        @click.stop="onSwitchMenuOpen"
        class="menu-icon"
        src="../assets/menu-icon.png"
        alt=""
      />
      <ul class="menu-list" v-show="showMenu">
        <li @click="onMenuClick(1)" class="active">
          链信云介绍<img src="../assets/right-icon.png" alt="" />
        </li>
        <li @click="onMenuClick(2)">
          链信云收费标准<img src="../assets/right-icon.png" alt="" />
        </li>
        <li @click="onMenuClick(4)">
          代币发行及配套服务<img src="../assets/right-icon.png" alt="" />
        </li>
        <li @click="onMenuClick(5)">
          数字钱包旗舰产品介绍<img src="../assets/right-icon.png" alt="" />
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="left-content">
        <side-menu :activeIndex="1"> </side-menu>
      </div>
      <div class="right-content">
        <img src="../assets/p-1.png" />
        <img src="../assets/p-2.png" />
        <img src="../assets/p-3.png" />
        <img src="../assets/p-4.png" />
        <img src="../assets/p-5.png" />
        <img src="../assets/p-6.png" />
        <img src="../assets/p-7.png" />
        <img src="../assets/p-8.png" />
        <img src="../assets/p-9.png" />
        <img src="../assets/p-10.png" />
        <img src="../assets/p-11.png" />
        <img src="../assets/p-12.png" />
        <img src="../assets/p-13.png" />
        <img src="../assets/p-14.png" />
        <img src="../assets/p-15.png" />
        <img src="../assets/p-16.png" />
        <img src="../assets/p-17.png" />
        <img src="../assets/p-18.png" />
        <img src="../assets/p-19.png" />
        <img src="../assets/p-20.png" />
        <img src="../assets/p-21.png" />
        <img src="../assets/p-22.png" />
        <img src="../assets/p-23.png" />
        <img src="../assets/p-24.png" />
        <img src="../assets/p-25.png" />
        <img src="../assets/p-26.png" />
        <img src="../assets/p-27.png" />
        <img src="../assets/p-28.png" />
        <img src="../assets/p-29.png" />
        <img src="../assets/p-30.png" />
        <img src="../assets/p-31.png" />
        <img src="../assets/p-32.png" />
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from "./sideMenu";
export default {
  components: {
    SideMenu
  },
  name: "",
  data() {
    return {
      showMenu: false,
      activeIndex: 1
    };
  },
  methods: {
    onPageClick() {
      this.showMenu = false;
    },
    onMenuClick(index) {
      if (index == 1) {
        this.$router.push({ path: "/" });
      } else if (index == 2) {
        this.$router.push({ path: "/cloudStandard" });
      } else if (index == 3) {
        this.$router.push({ path: "/topcreditbank" });
      } else if (index == 4) {
        this.$router.push({ path: "/supportService" });
      } else if (index == 5) {
        this.$router.push({ path: "/digitalWallet" });
      }
    },
    onSwitchMenuOpen() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.home-page {
  @media screen and (min-width: 1024px) {
    .header {
      .txtus {
        display: block;
      }
      .menu-icon {
        display: none;
      }
    }
    .right-content {
      margin-left: 200px;
    }
  }
  @media screen and (max-width: 1024px) {
    .content .right-content img {
      width: 92%;
      margin: 5px 4% 0px 4%;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
    }
    .left-content {
      display: none;
    }
    .header {
      .txtus {
        display: none;
      }
      .menu-icon {
        display: block;
      }
    }
  }
}
.home-page {
  .header {
    width: 100%;
    height: 50px;
    background-color: black;
    position: fixed;
    top: 0;
    background-color: #3f8faa;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
    border-bottom: #3f8faa solid 4px;
    .menu-icon {
      cursor: pointer;
      width: 20px;
      height: 15px;
      float: right;
      margin: 19px;
    }
  }
  .menu-list {
    background: white;
    width: 210px;
    position: absolute;
    padding: 10px 0 8px;
    right: 0px;
    top: 40px;
    border-radius: 3px;
    background: #f7f8fa;
    li {
      font-weight: bold;
      height: 42px;
      padding: 0 15px;
      line-height: 42px;
      cursor: pointer;
      text-align: left;
      color: #354052;
      margin: 0;
      list-style: none;
      &.active {
        background-color: #ecf2f5;
      }
      img {
        width: 18px;
        height: 18px;
        float: right;
        text-align: right;
        line-height: 36px;
        vertical-align: middle;
        margin-top: 12px;
      }
    }
  }
  .logo {
    width: 90px;
    margin-left: 20px;
    margin-top: 12px;
    float: left;
    text-align: right;
  }
  .txtus {
    float: right;
    text-align: right;
    line-height: 50px;
    margin-right: 15px;
    color: #fff;
  }
  .txtus a {
    color: #fff;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 20px;
    width: 100%;
    min-height: calc(100vh - 80px);
    background-color: #ecf0f6;
    overflow: auto;
    display: flex;
  }
  .right-content {
    // margin-left: 200px;
  }
  .right-content img {
    width: 60%;
    margin: 20px 20% 0px 20%;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  }
  .left-content {
    height: 100%;
    position: fixed;
    width: 210px;
    padding: 0px 0 475px;
    border-radius: 2px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
    background-color: #f7f8fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage.vue